import { useState } from "react";
import RateSummaryCard from "./review/RateSummaryCard";
import ConceptsSummary from "./review/ConceptsSummary";
import ConditionsSummary from "./review/ConditionsSummary";
import RateItemsSummary from "./review/RateItemsSummary";
import PublishChecklist from "./review/PublishChecklist";
import PublishModal from "./review/PublishModal";

export default function RateReviewStep({
  rate,
  concepts,
  conditions,
  items,
  places,
  hasErrorsConcepts,
  hasErrorsConditions,
  hasErrorsItems,
  onEditStep,
  onPublish,
}) {
  const [showPublish, setShowPublish] = useState(false);

  return (
    <section className="card">
      <h2>Paso 5 — Revisión y publicación</h2>
      <p className="wizard-guide">
        Revise la información completa de la tarifa antes de publicarla.
      </p>

      <div className="review-layout">

        {/* A — Acuerdo */}
        <RateSummaryCard rate={rate} onEdit={() => onEditStep(0)} editable={true} />

        {/* B — Conceptos */}
        <ConceptsSummary
          concepts={concepts}
          onEdit={() => onEditStep(1)}
          editable={true}
        />

        {/* C — Condiciones */}
        <ConditionsSummary
          conditions={conditions}
          places={places}
          onEdit={() => onEditStep(2)}
          editable={true}
        />

        {/* D — Reglas */}
        <RateItemsSummary
          items={items}
          concepts={concepts}
          conditions={conditions}
          places={places}
          onEdit={() => onEditStep(3)}
          editable={true}
        />

        {/* Checklist */}
        <PublishChecklist
          errorsConcepts={hasErrorsConcepts}
          errorsConditions={hasErrorsConditions}
          errorsItems={hasErrorsItems}
        />

        {showPublish && (
          <PublishModal
            onCancel={() => setShowPublish(false)}
            onConfirm={onPublish}
          />
        )}
      </div>

    </section>
    
  );
}
